module.exports = __webpack_public_path__ + "static/media/logo-slack.ca2e7a9a.svg";